<template>
  <div>
    <b-modal
      ref="select-transfer-method-modal"
      :titleHtml="modalTitle"
      @hide="hideModal"
      hide-footer
      size="lg"
      no-close-on-backdrop
    >
      <div class="payment-methods">
        <div class="row">
          <div
            class="col-md-6"
            v-if="hasPaymentGateway(ACCOUNTANT_PAYMENT_GATEWAY_ENUM.SEPAY)"
          >
            <div
              class="payment-method-card"
              @click="
                selectPaymentMethod(ACCOUNTANT_PAYMENT_GATEWAY_ENUM.SEPAY)
              "
            >
              <img :src="logoSePay" alt="SePay" class="payment-logo-sepay" />
              <h4>Thanh toán SEPAY (Mặc định)</h4>
              <p>Thanh toán qua ví cổng SEPAY</p>
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="hasPaymentGateway(ACCOUNTANT_PAYMENT_GATEWAY_ENUM.VNPAY)"
          >
            <div
              class="payment-method-card"
              @click="
                selectPaymentMethod(ACCOUNTANT_PAYMENT_GATEWAY_ENUM.VNPAY)
              "
            >
              <img :src="logoVNPay" alt="VNPay" class="payment-logo-vnpay" />
              <h4>Thanh toán VNPAY</h4>
              <p>Thanh toán qua cổng VNPAY</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { convertPrice } from '@/utils/common';
import { PAYMENT_TYPE, ACCOUNTANT_PAYMENT_GATEWAY_ENUM } from '@/utils/enum';

export default {
  props: [
    'billNumber',
    'transferAmount',
    'onGenerateQR',
    'storeId',
    'afterGenerateQR',
    'type',
    'payment',
    'billData',
  ],
  computed: {
    paymentAmount() {
      return this.convertPrice(this.payment.paymentAmount, 'vn-VN', {
        style: 'currency',
        currency: 'VND',
      });
    },
  },
  data() {
    return {
      ACCOUNTANT_PAYMENT_GATEWAY_ENUM,
      PAYMENT_TYPE: PAYMENT_TYPE,
      convertPrice,
      modalTitle: 'Chọn phương thức thanh toán chuyển khoản',
      countdown: 300,
      stopCountdown: 0,
      logoVNPay: 'media/logos/Logo-VNPAY-QR.webp',
      logoSePay: 'media/logos/sepay-blue-logo.png',
      minutes: null,
      seconds: null,
      timeTrigger: null,
      isExpired: false,
      paymentGateways: [],
    };
  },
  methods: {
    hasPaymentGateway(gateway) {
      return this.paymentGateways && this.paymentGateways.includes(gateway);
    },
    showModal: async function (payment) {
      this.paymentGateways = payment.paymentGateways || [];
      this.$refs['select-transfer-method-modal'].show();
    },
    hideModal: async function () {
      this.$refs['select-transfer-method-modal'].hide();
    },
    submit() {
      this.hideModal();
    },
    selectPaymentMethod(type) {
      this.$emit('select-payment-method', type);
      this.hideModal();
    },
  },
};
</script>

<style scoped>
.qr-content {
  padding: 20px 24px;
}
.qr-content__left {
  border-radius: 16px;
  padding: 30px;
  height: 300px;
  width: 100%;
}
.qr-content__image {
  /* Đảm bảo class name giống trong template */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.qr-content__image canvas {
  width: 200px;
  height: 200px;
  max-width: 200px;
  max-height: 200px;
  padding: 10px;
  background: white;
  border-radius: 8px;
}
.qr-content__image img {
  width: 200px;
  height: 200px;
  max-width: 200px;
  max-height: 200px;
  padding: 10px;
  background: white;
  border-radius: 8px;
}

.qr-content__wrapper {
  background: rgb(245, 245, 250);
  border-radius: 16px;
  min-with: 300px !important;
}
.qr-content__code {
  width: 240px;
  height: 240px;
  background: rgb(255, 255, 255);
  box-shadow: rgb(40 40 43 / 16%) 0px 2px 8px;
  border-radius: 8px;
  padding: 5px;
  margin: auto;
}
.qr-content__amount {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-top: 16px;
  font-size: 14px;
  line-height: 20px;
}
.qr-content__right {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
}

.step-description {
  color: rgb(128, 128, 137);
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}
.step-number {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgb(26, 148, 255);
  color: rgb(255, 255, 255);
  margin-right: 8px;
  font-weight: 500;
  flex-shrink: 0;
  text-align: center;
}
.qr-content__time {
  background: rgb(255, 245, 236);
  border-radius: 4px;
  padding: 13px 0px;
  display: block;
  text-align: center;
  margin-top: auto;
}
.supported-bank {
  padding: 24px;
  border-top: 1px solid rgb(235, 235, 240);
}
.supported-bank__title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: rgb(56, 56, 61);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 16px;
}

.supported-bank__list {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  max-height: 123px;
  overflow-y: scroll;
  gap: 16px 25px;
}

.countdown-time__style {
  text-align: center;
}

.min {
  background: rgb(253, 130, 10);
  color: rgb(255, 255, 255);
  padding: 4px 7px;
  display: inline-block;
  border-radius: 8px;
  margin: 0px 10px;
  font-size: 15px;
}

.second {
  background: rgb(253, 130, 10);
  color: rgb(255, 255, 255);
  padding: 4px 7px;
  display: inline-block;
  border-radius: 8px;
  margin: 0px 10px;
  font-size: 15px;
}
.separate-time__style {
  font-weight: 600;
  font-size: 16px;
}
.qr-code-icon {
  margin: 0 4px;
  font-size: 18px;
  color: #2a2727;
}
.qr-code-verify {
  font-weight: 700;
  color: #ffa800;
  margin: 0 4px;
  display: contents;
}
.container-qrcode {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.amount-text,
.amount-value {
  font-size: 17px;
}
.pd-10-percent {
  padding: 10%;
}

.text-center {
  text-align: center;
}

.payment-methods {
  padding: 20px;
}

.payment-method-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-method-card:hover {
  border-color: #1a94ff;
  box-shadow: 0 2px 8px rgba(40, 40, 43, 0.16);
}

.payment-logo-sepay {
  width: 80px;
  height: 27px;
  margin-bottom: 13px;
}

.payment-logo-vnpay {
  width: 80px;
  height: 18px;
  margin-bottom: 22px;
}

.payment-method-card h4 {
  margin-bottom: 10px;
  color: #38383d;
}

.payment-method-card p {
  color: #808089;
  font-size: 14px;
}
</style>
